import React from 'react';
import surfaceNode from 'graphql/surface-node/queries/surface-node';
import { NodeFormInitialValues } from 'types';

export default function useSurfaceNodeInitialValuesFromServer<T>(
  formInitialValues: T | NodeFormInitialValues,
): { initialValues: T | NodeFormInitialValues; isLoading: boolean } {
  const [initialValues, setInitialValues] = React.useState<
    T | NodeFormInitialValues
  >(formInitialValues);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    // @ts-ignore
    if (formInitialValues.id) {
      setIsLoading(true);

      surfaceNode(
        // @ts-ignore
        { id: formInitialValues.id },
        { fetchPolicy: 'no-cache' },
      )
        .then((response) => {
          if (response.isSuccess) {
            setInitialValues(response.getField('data'));
          }
        })
        .finally(() => {
          setTimeout(() => setIsLoading(false));
        });
    }
    // @ts-ignore
  }, [formInitialValues.id]);

  return { initialValues, isLoading };
}
